import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AirconUnit } from '@brokerportal/common/models/application';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AirconUnitsService {
    constructor(private httpClient: HttpClient) {}

    getUnits(applicationGuid: string): Observable<AirconUnit[]> {
        return this.httpClient.get<AirconUnit[]>(
            `${environment.api.baseUrl}/portal/details/${applicationGuid}/aircon-units`
        );
    }
}
